import type React from 'react';

const WinSvgIcon: React.FC<React.SVGAttributes<SVGElement>> = () => {
  return (
    <svg width="175" height="92" viewBox="0 0 175 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M105.917 23.8913H90.0966V12.8973H86.6107V12.361L98.1409 0.830811L109.403 12.361V12.8973H105.917V23.8913ZM90.0966 92V30.5949H105.917V92H90.0966ZM174.294 91.7318H158.473V55.8005C158.473 52.3146 157.401 43.4658 146.943 43.4658C139.972 43.4658 134.877 48.8287 134.877 55.8005V91.7318H119.056V30.0586H134.072V35.9578C138.094 31.3993 143.457 28.4497 149.893 28.4497C164.373 28.4497 174.026 39.4436 174.026 55.5323V91.7318H174.294ZM68.1087 30.5949H83.6611L67.0362 91.7318H66.4999H50.9475H50.4112L41.5624 59.2863L32.7136 91.7318H32.1774H16.8931H16.625L0 30.5949H15.5524L24.6693 68.6714L33.7862 30.5949H49.3386L58.4555 68.6714L68.1087 30.5949Z" />
    </svg>
  );
};

export default WinSvgIcon;
